import styled, { css } from 'styled-components';

export const AddVaultCotainerStyled = styled.div`
  display: grid;
  grid-template-columns: 20% 29% 17% 17% 17%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  border-left: 0;
  ${({ theme }) =>
    css`
      padding: ${theme.spacings[500]} ${theme.spacings[400]};
      border: solid 1px ${theme.colors.grey[300]};
      border-left: ${theme.spacings[300]} solid ${theme.colors.bechtel.blue[300]};
      border-radius: ${theme.radii[300]};
      margin-top: ${theme.spacings[450]};
    `}
`;
